import { ProfileAvatar } from "../../../profile/ProfileAvatar";
import { Stack, Typography } from "@mui/material";
import { ReuseEllipsisTooltip } from "../../ReuseEllipsisTooltip";

type Props = {
  fullname: string;
  avatar_url: string;
  email: string;
  isCurrentUser: boolean;
};

export const NameBlock = ({
  fullname,
  avatar_url,
  email,
  isCurrentUser,
}: Props) => {
  return (
    <Stack flexDirection="row" gap="10px" alignItems="center">
      <ProfileAvatar avatar_url={avatar_url} height="24px" width="24px" />
      <Stack paddingY="4px" maxWidth={"186px"}>
        <Typography
          sx={{
            fontSize: 14,
            lineHeight: "22px",
            fontWeight: "400",
            color: "#232323",
          }}
        >
          {fullname}{" "}
          {isCurrentUser && <span style={{ color: "#9B9B9B" }}>(you)</span>}
        </Typography>
        <ReuseEllipsisTooltip
          tooltip={email}
          children={email}
          style={{
            fontSize: "12px",
            lineHeight: "20px",
            fontWeight: 400,
            color: "#797979",
          }}
        />
      </Stack>
    </Stack>
  );
};
